import styles from '../../styles/lit-bundle/shared.scss?inline';
import { CSSResult, unsafeCSS } from 'lit';

export const sharedCss: CSSResult = unsafeCSS(styles);
